<template>
  <p :style="style" v-if="text">
    {{ text }}
  </p>
  <p :style="style" v-else>
    <slot></slot>
  </p>
</template>

<script>
export default {
  name: 'AppTag',
  props: {
    text: String,
    background: String,
  },
  computed: {
    style() {
      return {
        fontSize: '0.9rem',
        width: 'fit-content',
        heigth: '10px',
        background: this.background || '#e3e3e3',
        textAlign: 'center',
        borderRadius: '3px',
        padding: '3px 8px',
      };
    },
  },
};
</script>

<style>
</style>
